/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { type ReactNode } from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import Heading from '@atlaskit/heading/heading';
import ErrorIcon from '@atlaskit/icon/core/status-error';
import { Flex, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { defaultErrorText } from './default-error-text';

const styles = cssMap({
	errorContainer: {
		minWidth: '160px',
		paddingBlockStart: token('space.250'),
		paddingInlineEnd: token('space.250'),
		paddingBlockEnd: token('space.250'),
		paddingInlineStart: token('space.250'),
	},
});

export type PopupErrorFallbackProps = {
	error: Error;
	errorText?: ReactNode;
	errorTitle?: ReactNode;
};

export function PopupErrorFallback({
	errorText,
	errorTitle,
}: PopupErrorFallbackProps): React.JSX.Element {
	return (
		<Flex justifyContent="center" xcss={styles.errorContainer}>
			<Stack space="space.200">
				<Flex gap="space.100" alignItems="center">
					{/* Decorative; the title next to it is the accessible name */}
					<ErrorIcon label="" color={token('color.icon.danger')} />
					<Heading size="small" as="h2">
						{errorTitle ?? "Couldn't load popup content"}
					</Heading>
				</Flex>
				<Text as="p">{errorText ?? defaultErrorText}</Text>
			</Stack>
		</Flex>
	);
}
